import { useCallback } from 'react';
import { usePopup } from 'Util/usePopup';

export const useError = () => {
  const { showOneButtonExclamationDialog } = usePopup();

  const showErrorPopup = useCallback(
    ({ id, text, onClose = () => {} }) => {
      if (!id && !text) return;
      showOneButtonExclamationDialog({
        title: id ? id : text,
        needIntl: id ? true : false,
        onClose,
      });
    },
    [showOneButtonExclamationDialog]
  );

  return { showErrorPopup };
};
